var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Page not found")]),_vm._v(" "),_c('span',[_vm._v("Sorry, the page you're looking for doesn't exist.")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")]),_vm._v("\n  Go home\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43551fbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = 294
// module chunks = 4